import { useMutation } from '@apollo/client';
import { CanDeleteOrgDocument, CreateOrgDocument, UpdateOrgDocument, useDeleteOrgMutation as _useDeleteOrgMutation, useGetOrgByIdLazyQuery as _useGetOrgByIdLazyQuery, useGetOrgByIdQuery as _useGetOrgByIdQuery, useGetOrgsListLazyQuery as _useGetOrgsListLazyQuery, useGetOrgsListQuery as _useGetOrgsListQuery, useGetUserOrgsByUserIdLazyQuery as _useGetUserOrgsByUserIdLazyQuery, } from '../generated/graphql-types';
export const useGetOrgsListQuery = (input, skip = false) => {
    const { data, error, loading, refetch } = _useGetOrgsListQuery({
        fetchPolicy: 'no-cache',
        variables: {
            data: input,
        },
        skip,
    });
    return {
        error,
        loading,
        data: data?.getOrgsList,
        refetch,
    };
};
export const useGetOrgsListLazyQuery = (input) => {
    const [getOrgsList, { data, error, loading }] = _useGetOrgsListLazyQuery({
        fetchPolicy: 'no-cache',
        variables: {
            data: input,
        },
    });
    return {
        error,
        loading,
        data: data?.getOrgsList,
        getOrgsList,
    };
};
export const useGetOrgByIdQuery = (orgId) => {
    const { data, error, loading } = _useGetOrgByIdQuery({
        variables: {
            orgId,
        },
    });
    return {
        error,
        loading,
        data: data?.getOrgById,
    };
};
export const useGetOrgByIdLazyQuery = (orgId) => {
    const [getOrgById, { data, error, loading }] = _useGetOrgByIdLazyQuery({
        variables: {
            orgId,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.getOrgById,
        getOrgById,
    };
};
export const useGetUserOrgsByUserIdLazyQuery = (userId) => {
    const [getUserOrgsByUserId, { data, error, loading },] = _useGetUserOrgsByUserIdLazyQuery({
        variables: {
            userId,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.getUserOrgsByUserId,
        getUserOrgsByUserId,
    };
};
export const useCreateOrgMutation = () => {
    const [_createOrg, { data: result, error, loading }] = useMutation(CreateOrgDocument);
    return {
        data: result?.Org_create,
        error,
        loading,
        createOrg: (data) => _createOrg({
            variables: {
                data,
            },
        }),
    };
};
export const useUpdateOrgMutation = () => {
    const [_updateOrg, { data: result, error, loading }] = useMutation(UpdateOrgDocument);
    return {
        data: result?.Org_update,
        error,
        loading,
        updateOrg: (data) => _updateOrg({
            variables: {
                data,
            },
        }),
    };
};
export const useDeleteOrgMutation = (onComplete, onError, orgId) => _useDeleteOrgMutation({
    variables: {
        orgId,
    },
    update: (cache, result) => {
        onComplete(result?.data.Org_delete);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useCanDeleteOrgMutation = () => {
    const [_canDeleteOrg, { data: result, error, loading }] = useMutation(CanDeleteOrgDocument);
    return {
        data: result?.Org_canDelete,
        error,
        loading,
        canDeleteOrg: (orgId) => _canDeleteOrg({
            variables: {
                orgId,
            },
        }),
    };
};
//# sourceMappingURL=org-service.js.map